import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef
} from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { formatDistance } from 'date-fns'
import { ToastrService } from 'ngx-toastr';
import { TranslaterService } from 'src/app/services/translater.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsComponent } from '../notifications/notifications.component';
import { BaseApi } from 'src/backend/api/base-api';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { NotificationService } from 'src/backend/services/notification.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { lean_features } from 'src/@smartmanufacturing/common/custom_methods';
import * as CryptoJS from "crypto-js";
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { finalize } from 'rxjs/operators';
import { OpenaiChatService } from 'src/app/services/openai-chat.service';
import { DynamicDashboardService } from 'src/app/services/dynamic-dashboard.service';
import { VersionService } from 'src/app/services/version.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import versionData from 'src/assets/js/version.json';

interface Version {
  Id: number;
  VersionNumber: string;
  CreatedDate: string;
  Approved: boolean;
  Description: string;
  VersionFile: string;
  UserCode: string;
}
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig],
})
export class NavbarComponent implements OnInit {
  @ViewChild(NotificationsComponent) child!: NotificationsComponent;
  @ViewChild('resetPasswordDialog') private resetPasswordDialog!: TemplateRef<any>;
  @ViewChild('o3gpt') private o3gpt!: TemplateRef<any>;
  @Input() isMenuOpen!: boolean;
  @Output() mobMenuTogglerEvent = new EventEmitter();
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;
  @ViewChild('pdfViewerTemplate') pdfViewerTemplate!: TemplateRef<any>;
  baseUrl = Constants.BLOB_STORAGE_URL;
  versions: Version[] = [];
  showApproveButton: boolean = false;
  searchForm!: FormGroup;
  notifcationCount = 0;
  isSarchFormVisible = false;
  userImage!: any;
  urll: any;
  searchValue = new FormControl();
  imageSrc: any = '/assets/images/english.png';
  chatBotImageSrc: any = 'assets/images/chatBot-logo.png'
  languageDir = 'ltr';
  public toastrnotifications: any[] = [];
  translateForm!: FormGroup;
  userProfile: LoggedUser;
  AllMenuList: { Text: string }[];
  filteredOptions: Observable<any[]>;
  filteredModules!: any[];
  ATMenuList: any = [];
  groupSession: any;
  plantSession: any;
  authToken: any;
  groupName: any;
  plantName: any;
  currentMenuId: string = '';
  homeCardList: any[] = [];
  user!: LoggedUser;
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);

  resetPasswordForm: FormGroup;
  showOldPassword: any = false;
  showPassword: any = false;
  showConfirmPassword: any = false;
  isLoader: boolean = false;
  chats = [
    { isBot: true, message: 'Hi, how can I help you?', time: new Date() }
  ];
  userInput = '';
  userCode: any;
  safeHtml: SafeHtml;
  versionData = versionData
  selectedVersion: any;
  pdfSrc: string;
  langObj: any;
  fileMode: any;
  isLoading: boolean=true;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private notificationService: NotificationService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private commonService: CommonService,
    private baseApi: BaseApi,
    private openaiService: OpenaiChatService,
    private dynamicService: DynamicDashboardService,
    private userManagementService: UserManagementService,
    private versionService: VersionService,
    private sanitizer: DomSanitizer
  ) {
    this.translateForm = this.formBuilder.group({
      languagvalue: [''],
    });
  }

  ngOnInit(): void {
    this.getSessionData();
    this.changeLangFromLocalStorage();
    this.getLangWords();

    this.searchForm = this.formBuilder.group({
      searchValue: [''],
    });

    this.resetPasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.pattern(/^\S.*$/)]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmNewPassword: ['', Validators.required],
    });

    let currentlang = localStorage.getItem('Language_Name') || 'en';
    if (currentlang === 'en') {
      this.imageSrc = '/assets/images/english.png';
    } else if (currentlang === 'ar') {
      this.imageSrc = '/assets/images/arabic.png';
    } else if (currentlang === 'fr') {
      this.imageSrc = '/assets/images/french.png';
    } else if (currentlang === 'sp') {
      this.imageSrc = '/assets/images/spanish.png';
    } else if (currentlang === 'gr') {
      this.imageSrc = '/assets/images/german.png';
    } else if (currentlang === 'du') {
      this.imageSrc = '/assets/images/dutch.png';
    }
    this.translateForm
      .get('languagvalue')
      ?.setValue(currentlang === undefined ? 'en' : currentlang);
    this.notificationService.notificationCount$.subscribe({
      next: (resp) => {
        this.notifcationCount = resp;
      },
      error: ({ error }) => { },
    });
    this.getProfileInformation();
    this.getMenulist();
    // this.getMenuCards()
    this.getVersionInformation();
    this.checkIfVersionIsRead();
  }
  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId: localStorage.getItem('Language_Name') === 'en' ? 1 : localStorage.getItem('Language_Name') === 'ar' ? 2 : localStorage.getItem('Language_Name') === 'fr' ? 3 : localStorage.getItem('Language_Name') === 'sp' ? 4 : localStorage.getItem('Language_Name') === 'gr' ? 5 : localStorage.getItem('Language_Name') === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        if (this.hasRealTranslation(elem.tagName, elem.translatedValue)) {
          obj[elem.tagName] = elem.translatedValue;
        }

      });
      this.langObj = obj;
      if (this.langObj) {
      }
    });
  }

  getProfileInformation() {
    this.userProfile = this.baseApi.getUserSession();
    this.userImage = this.userProfile?.picture;
  }

  changeDateFormat(date: any): any {
    return formatDistance(new Date(date), new Date(), {
      addSuffix: true,
    });
  }
  showNotificationBar(): void {
    this.child.showNotificationPanel();
  }
  changeLangFromLocalStorage() {
    const currentLang = localStorage.getItem('Language_Name') || 'en';
    this.changeLang(currentLang);
    this.getLangWords();
  }
  changeLang(currentlang) {
    if (currentlang === 'en') {
      this.getLangWords();
      this.imageSrc = '/assets/images/english.png';
      this.languageDir = 'ltr';
    } else if (currentlang === 'ar') {
      this.getLangWords();
      this.imageSrc = '/assets/images/arabic.png';
      this.languageDir = 'rtl';
    } else if (currentlang === 'fr') {
      this.getLangWords();
      this.imageSrc = '/assets/images/french.png';
      this.languageDir = 'ltr';
    } else if (currentlang === 'sp') {
      this.getLangWords();
      this.imageSrc = '/assets/images/spanish.png';
      this.languageDir = 'ltr';
    } else if (currentlang === 'gr') {
      this.getLangWords();
      this.imageSrc = '/assets/images/german.png';
      this.languageDir = 'ltr';
    } else if (currentlang === 'du') {
      this.getLangWords();
      this.imageSrc = '/assets/images/dutch.png';
      this.languageDir = 'ltr';
    }
  }

  onSubmit(): void {
    const searchValue = this.searchForm.value;
  }

  getMenulist(): any {
    const obj = {};
    this.userManagementService.GetSearchMenulist(obj).subscribe(
      (data: any) => {
        this.AllMenuList = data.mennulist;
        this.filteredOptions = this.searchValue.valueChanges.pipe(
          startWith(''),
          map((value) => {
            return this.AllMenuList.filter((option) =>
              option.Text?.toLowerCase().includes(value?.toLowerCase())
            );
          })
        );
        if (this.AllMenuList.length > 0) {
          this.filteredModules = this.AllMenuList.slice();
        }
      },
      (error) => {
        this.toaster.error(this.getTranslatedMsg('Error', 'Error'), error.ErrorMessage);
      }
    );
  }

  mobMenuToggler(): void {
    this.mobMenuTogglerEvent.emit(this.isMenuOpen);
  }

  toggleSearchForm(): void {
    this.isSarchFormVisible = !this.isSarchFormVisible;
  }

  logoutUser(): void {
    this.userManagementService.LogoutUser().subscribe(
      (data: any) => {
        if (data.message === 'Success') {
          this.toaster.success(this.getTranslatedMsg('Success', 'Success'), this.getTranslatedMsg('LogoutSuccessful', 'Logout successful'));
        } else {
          console.error('Unexpected response:', data);
        }
      },
      (error: any) => {
        this.toaster.error(this.getTranslatedMsg('Error', 'Error'), error.message);
      }
    );
  }

  logout(): void {
    this.logoutUser();
    this.baseApi.removeTokenFromStorage();
    this.baseApi.removePlantCodeFromStorage();
    this.baseApi.removeGroupCodeFromStorage();
    this.baseApi.removeUserSession();
    this.baseApi.removeUserMenusSession();
    this.baseApi.removeUserPermissionsSession();
    this.baseApi.removeGroupFromStorage();
    this.baseApi.removePlantFromStorage();
    this.baseApi.removeCurrentMenuID();
    this.baseApi.removeCardsSession();
    this.router.navigate(['/login']);
  }

  changeValue(event: any) {

    // if (event?.ApplicationVariant === 'Lean') {
    if (event?.ApplicationVariant === Constants.LEAN_APP_NAME || event?.ApplicationVariant === Constants.UI_FORM_BUILDER_APP_NAME || event?.ApplicationVariant === Constants.UTILITY_APP_NAME) {
      const appURL = this.baseApi.getAppURL(event?.ApplicationVariant);
      const plantCode: string = this.baseApi.getPlantCodeFromStorage();
      const groupCode: string = this.baseApi.getGroupCodeFromStorage();
      const queryParams = {
        email: this.userProfile?.userName,
        plantCode,
        groupCode,
        menuId: event?.MenuId,
        languageName: localStorage.getItem('Language_Name'),
        token: this.baseApi.getTokenFromStorage(),
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(queryParams),
        this.key,
        { iv: this.iv }
      );
      this.openUrlWithParameters(appURL, { encrypted: encrypted.toString() })
    } else {
      this.baseApi.saveCurrentMenuID(event?.MenuId);
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate([event.Url]));
      this.searchValue.reset();
      const buttonElement: HTMLElement = document.querySelector('.search-btn');
      buttonElement.focus();
    }
    this.getMenulist()
  }
  tst(eventdata: any) {

    console.log('eventData', eventdata);
    console.log('eventData', eventdata);

  }

  openUrlWithParameters(
    url: string,
    parameters: { [key: string]: string }
  ): void {
    const queryString = Object.keys(parameters)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`
      )
      .join('&');
    const urlWithParameters = `${url}?${queryString}`;
    window.open(urlWithParameters, '_self');
  }

  onlyUnique(value, index, self): any {
    return self.indexOf(value) === index;
  }

  ReturnHome(IdMenu: any): void {
    const loggedInUser = JSON.parse(localStorage.getItem('logged_in_user'));
    const roles = loggedInUser.roles;
    if (roles.includes('Super Admin') || roles.includes('Group Admin')) {
      this.urll = 'home';
    } else {
      this.urll = 'landing';
    }
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([this.urll]));
  }

  // ReturnHome(IdMenu: any): any {
  //   this.urll = 'home';
  //   this.router
  //     .navigateByUrl('/', { skipLocationChange: true })
  //     .then(() => this.router.navigate([this.urll]));
  // }
  cleartAlltoaster(): any {
    this.toaster.clear();
    this.toastrnotifications = [];
  }
  navigateToUserProfile() {
    this.router.navigate(['user-access/user-profile']);
  }
  navigateToUserPlants() {
    this.router.navigate(['user-access/user-plants']);
  }

  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.userCode = this.baseApi.getUserSession();
    // this.authToken = this.baseApi.getTokenFromStorage()
    this.groupName = this.groupSession?.groupName;
    this.plantName = this.plantSession?.plantName;
  }

  showResetPasswordPopup(): void {
    this.resetPasswordForm.reset();
    this.dialog.open(this.resetPasswordDialog, {
      width: '550px',
      height: '460px',
    }).afterClosed().subscribe(result => {
      this.resetPasswordForm.reset();
      this.showOldPassword = false;
      this.showPassword = false;
      this.showConfirmPassword = false;
    });
  }

  resetPassword() {
    if (this.resetPasswordForm.value.newPassword !== this.resetPasswordForm.value.confirmNewPassword) {
      this.toaster.error(this.getTranslatedMsg('ConfirmPasswordMustMatch', "Confirm Password Must Match"));
      return;
    }
    const key = {
      userId: this.baseApi.getUserSession()?.userId,
      currentPassword: this.resetPasswordForm.value.oldPassword,
      newPassword: this.resetPasswordForm.value.newPassword,
      confirmNewPassword: this.resetPasswordForm.value.confirmNewPassword
    }
    this.spinner.show();
    this.commonService.resetUserPassword(key).pipe(finalize(() => this.spinner.hide())).subscribe(
      (response: any) => {
        if (response.message == "Password Reset Successfully") {
          this.toaster.success(response.message);
          return;
        }
        else {
          this.toaster.error(response.message);
        }
      },
      ({ error }: any) => {
        this.toaster.error(this.getTranslatedMsg('Error', 'error'), error.message);
      }
    );
  }

  showHideOldPassword(event: any) {
    this.showOldPassword = !this.showOldPassword;
  }

  showHidePassword(event: any) {
    this.showPassword = !this.showPassword;
  }

  showHideConfirmPassword(event: any) {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  showChatModel(): void {

    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
    this.openaiService.loadComponent();
    setTimeout(() => {
      const chatModel = document.querySelector('#openai_chat_model');
      if (chatModel) {
        chatModel.classList.remove('chat_hide')
        chatModel.classList.add('chat_show')
      }
    }, 200);
    // showToast = () => {
    //   this.toastRef = this.toaster.show('Test', '', {
    //       toastClass: 'toast border-red',
    //       positionClass: 'bottom-left',
    //       // @ts-ignore
    //       buttons: this.toastButtons,
    //       timeOut: 0,
    //       newestOnTop: true,
    //       closeButton: true,
    //       enableHtml: true,
    //       disableTimeOut: true,
    //       tapToDismiss: true
    //     })
    //     .onAction.subscribe(x => {
    //       alert(`${x.title} is pressed`);
    //       console.log(x);
    //     });
    // };
    // public OnPageChange(event: PageEvent){
    //   let startIndex = event.pageIndex * event.pageSize;
    //   let endIndex = startIndex + event.pageSize;
    //   if(endIndex > this.notifications.length){
    //     endIndex = this.notifications.length;
    //   }
    //   this.pagedNotificationList = this.notifications.slice(startIndex, endIndex);
    // }
    // onScrollDown(ev: any) {
    //   console.log("scrolled down!!", ev);
    //   this.sum += 5;
    //   this.appendItems();
    // }

    // onScrollUp(ev: any) {
    //   console.log("scrolled up!", ev);
    //   this.sum += 5;
    //   this.prependItems();
    // }

    // appendItems() {
    //   this.addItems("push");
    // }

    // prependItems() {
    //   this.addItems("unshift");
    // }

    // addItems(_method: string) {
    //   if(this.notificationsLength > this.sum){
    //     for (let i = 0; i < this.sum; ++i) {
    //       if( _method === 'push'){
    //         this.pagedNotificationList.push([i].join(""));
    //       }else if( _method === 'unshift'){
    //         this.pagedNotificationList.unshift([i].join(""));
    //       }
    //     }
    //   } else {}
    // }
  }
  //=============================================================== O3 GPT ============================================================//
  openPopupO3GPT() {

    let dialogRef = this.dialog.open(this.o3gpt, {
      minWidth: '60%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {

    });
    dialogRef.afterClosed().subscribe((res: any) => {

    });
  }
  sendMessage() {
    // Prevent sending empty messages
    this.isLoader = true;
    if (!this.userInput.trim()) {
      return;
    }
    this.chats.push({ isBot: false, message: this.userInput, time: new Date() });
    // Add the user's message to the conversation
    const data = {
      query: this.userInput
    }
    this.dynamicService.getResponseVectara(data).subscribe(data => {
      this.chats.push({ isBot: true, message: data.responseSet[0].summary[0].text, time: new Date() });
      this.userInput = '';
      this.isLoader = false;
    });

  }
  clearMessage() {
    this.chats = [];
    this.chats = [
      { isBot: true, message: 'Hi, how can I help you?', time: new Date() }
    ];
  }
  openDialog(version: any): void {
    this.selectedVersion = version;
    this.showApproveButton = this.selectedVersion.Approved
    this.safeHtml = this.sanitizeHtml(this.selectedVersion.Description);
    console.log("html list", this.safeHtml)
    this.dialog.open(this.dialogTemplate, {
      width: '40vw',
      height: 'auto',
      maxHeight: '80vh',
      panelClass: 'custom-dialog-container'
    });
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  onApprove(): void {
    const payload = {
      versionId: this.selectedVersion.Id
    }
    this.versionService.approveVersion(payload).subscribe(
      response => {
        this.selectedVersion.Approved = true;
        this.toaster.success(this.getTranslatedMsg('Success', 'Success'), this.getTranslatedMsg('VersionApprovedSuccessfully', 'Version approved successfully!'));
        this.getVersionInformation();
        this.dialog.closeAll();
      },
      error => {
        this.toaster.error(this.getTranslatedMsg('Error', 'Error'), this.getTranslatedMsg('FailedToApproveVersion', 'Failed to approve version.'));
      }
    );
  }
  viewPDF(): void {
    this.fileMode = 'VersionFile';
    const encodedPath = this.selectedVersion.VersionFile;
    const decodedPath = decodeURIComponent(encodedPath);
    this.pdfSrc = this.baseUrl + decodedPath;

    this.dialog.open(this.pdfViewerTemplate, {
      width: '80vw',
      height: '80vh',
      panelClass: 'custom-dialog-container'
    });
  }
  viewManualPDF(): void {
    this.fileMode = 'UserManual';
    const encodedPath = this.selectedVersion.UserManual;
    const decodedPath = decodeURIComponent(encodedPath);
    this.pdfSrc = this.baseUrl + decodedPath;
    // this.pdfSrc = "https://o3storagenew.blob.core.windows.net/o3-live-attachments/newrelease/O3ai%20User%20Manual_V2_(20250309T081042911).pdf";


    this.dialog.open(this.pdfViewerTemplate, {
      width: '80vw',
      height: '80vh',
      panelClass: 'custom-dialog-container'
    });
    this.isLoading = true; 
  }

  onPDFLoad() {
    this.isLoading = false;
    this.spinner.hide();
  }

  onPDFError() {
    this.isLoading = false;
    this.spinner.hide();
  }
  closePDFViewer()
  {
    this.pdfSrc = null;
  }
  downloadPDF(): void {
    
    const encodedPath = this.selectedVersion[this.fileMode === 'VersionFile' ? 'VersionFile' : 'UserManual'];
    const decodedPath = decodeURIComponent(encodedPath);
    const downloadUrl = this.baseUrl + decodedPath;

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = decodedPath.substring(decodedPath.lastIndexOf('/') + 1);
    link.click();
  }
  getVersionInformation(): void {
    this.versionService.getAllVersionInformation().subscribe(
      data => {
        if (!data.isError) {
          this.checkIfVersionIsRead()
          this.versions = data.data;
          this.versions.forEach(version => {
            version.Description = this.addCustomClassToLists(version.Description);
          });
        } else {
          console.error(data.message);
        }
      },
      error => {
        console.error('Error fetching version information:', error);
      }
    );
  }
  readStatuses: any
  markUnread: boolean = false
  checkIfVersionIsRead(): void {
    this.versionService.getIsVersionRead().subscribe(
      data => {
        if (!data.isError) {
          this.readStatuses = data.data;
          this.updateVersionStatuses();
        } else {
          console.error(data.message);
        }
      },
      error => {
        console.error('Error checking version read status:', error);
      }
    );
  }
  updateVersionStatuses(): void {
    this.versions.forEach(version => {
      const status = this.readStatuses.find(status => status.VersionId === version.Id);
      if (status) {
        version.Approved = status.Approved;
      }
    });
  }
  istatus: any = false;

  isNewRelease(): boolean {
    if (!this.versions || !this.readStatuses) {
      return false; // or handle this case as appropriate
    }
    const version = this.versions.find(v => v.VersionNumber === versionData.version);

    if (version) {
      // Find the read status for the found version
      const istatus = this.readStatuses.find(status => status.VersionId === version.Id);
      return istatus ? !istatus.Approved : true; // Default to true if status is not found
    }
    return this.versions.some(version =>
      this.readStatuses.some(status => version.VersionNumber === versionData.version && !this.istatus.Approved)
    );
  }


  addCustomClassToLists(description: string): string {
    return description.replace(/<ol>/g, '<ol style="list-style-type:decimal; margin-left:30px;">')
      .replace(/<ul>/g, '<ul style="list-style-type:disc; margin-left:30px;">');
  }
  stripHtmlTags(str: string): string {
    if (!str) return '';
    return str.replace(/<\/?[^>]+(>|$)/g, "");
  }

  // A tag that exists in the Language screen but was never given a value for the
  // current language comes back empty or still holding the English text. Treating
  // those as missing lets the i18n fallback (assets/i18n/*.json) supply the wording.
  private hasRealTranslation(tagName: string, value: string): boolean {
    if (!value || !value.trim()) {
      return false;
    }
    const lang = this.translate ? this.translate.currentLang : 'en';
    if (!lang || lang === 'en') {
      return true;
    }
    if (lang === 'ar') {
      return /[\u0600-\u06FF]/.test(value);
    }
    const strip = (text: string) => text.replace(/[^A-Za-z0-9]/g, '').toLowerCase();
    return strip(value) !== strip(tagName);
  }

  // Resolution order: the page tags from langObj, then assets/i18n/<active language>.json
  // via ngx-translate. The literal fallback is a last resort for an unconfigured tag.
  public getTranslatedMsg(tag: string, fallback?: string): string {
    if (this.langObj && this.langObj[tag]) {
      return this.langObj[tag];
    }
    const translated = this.translate ? this.translate.instant(tag) : tag;
    if (translated && translated !== tag) {
      return translated;
    }
    return fallback === undefined || fallback === null ? tag : fallback;
  }
}
